const EventNames = require('@/lib/Events/EventNames');

const numPadDirective = function () {
    return {
        restrict: 'E',
        scope: {
            numPad: '=',
            listen: '=',
        },
        templateUrl: 'partials/directives/dt-num-pad.html',
        link: function ($scope) {
            $scope.$on(EventNames.KEY_DOWN, function (event, originalEvent) {
                if ($scope.listen !== false) {
                    $scope.numPad.keyDownReceived(originalEvent, $scope);
                }
            });
        },
    };
};

module.exports = numPadDirective;
